<template>
      <div class="col-md-12">
          <div class="card card-default">
            <div class="card-header">
                  <div class="h5 mt-2"><i class="text-success fas fa-check-circle fa-lg"></i><span class="ml-2">You're all caught up!</span></div>
            </div>

            <div class="card-body">     
                  <p class="mb-0">There are no {{object}} yet.</p>
            </div>
          </div>
      </div>
</template>

<script>
    export default {

        props: ['object'],

        created: function() {

        },

        mounted: function() {
        },

        data: function() {
            return {
            };
        },

        computed: {
        },

        methods: {
        }
    }
</script>
